import { Inject, Pipe, PipeTransform } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { pluck } from '../../../helpers/utils';
import { ScSelectOptions } from '../../../models/table.model';
import { RestService } from '../../../services/rest-service.service';

@Pipe({
  name: 'externalFetch'
})
export class ExternalFetchPipe implements PipeTransform {
  constructor(private _restService: RestService, @Inject('env') private _env: any) {}

  transform(options: ScSelectOptions): Observable<any[]> {
    if (options.type === 'internal') {
      return of(options.fields);
    }

    const { fetchOptions } = options;

    const filters = fetchOptions.filters ? fetchOptions.filters : [];

    return this._restService
      .post(`${this._env.apiURL}/Endpoint/${fetchOptions.endpoint}`, {
        filters
      })
      .pipe(
        map(({ items }) =>
          items.map(v => {
            const value = typeof fetchOptions.prop === 'function' ? fetchOptions.prop(v) : pluck(v, fetchOptions.prop);
            return {
              ...v,
              name: value,
              id: v[fetchOptions.itemId]
            };
          })
        )
      );
  }
}
